<template>
	<div>
		<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog modal-sm" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<div class="btn-toolbar pull-right" role="toolbar">
							<div class="btn-group" role="group" aria-label="...">
								<button type="button" class="close" data-dismiss="modal" aria-label="Close">
									<span aria-hidden="true">&times;</span>
								</button>
							</div>
						</div>
						<h4 class="modal-title">Tipo de documento</h4>
					</div>
					<div class="list-group m-b-0">
						<button @click="addRequest()" type="button" class="list-group-item">
							<i aria-hidden="true" class="fa fa-info-circle fa-fw"></i>
							Solicitud
							<i class="fa fa-plus pull-right" aria-hidden="true"></i>
						</button>
						<button @click="addBudget()" type="button" class="list-group-item">
							<i aria-hidden="true" class="fa fa-clipboard fa-fw"></i>
							Presupuesto
							<i class="fa fa-plus pull-right" aria-hidden="true"></i>
						</button>
						<button @click="addOrder()" type="button" class="list-group-item">
							<i aria-hidden="true" class="fa fa-file-text"></i>
							Pedido
							<i class="fa fa-plus pull-right" aria-hidden="true"></i>
						</button>
						<button @click="addInvoice()" type="button" class="list-group-item">
							<i aria-hidden="true" class="fa fa-clipboard"></i>
							Factura
							<i class="fa fa-plus pull-right" aria-hidden="true"></i>
						</button>
						<button @click="addProject()" type="button" class="list-group-item">
							<i class="fa fa-folder-o" aria-hidden="true"></i>
							Proyecto
							<i class="fa fa-plus pull-right" aria-hidden="true"></i>
						</button>
						<button @click="addAgreement()" type="button" class="list-group-item">
							<i aria-hidden="true" class="fa fa-handshake-o"></i>
							Contrato
							<i class="fa fa-plus pull-right" aria-hidden="true"></i>
						</button>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
					</div>
				</div>
			</div>
		</div>

		<create-project
			@reload="reload"
			@createTask="openTaskCreate"
			ref="createProject"
			:user="user"
			:isAuth="isAuth">
		</create-project>

		<task-create
			ref="taskCreate"
			@openCreateSchedule="openCreateSchedule"
			@reload="reload"
			:user="user"
			:isAuth="isAuth">
		</task-create>

		<schedule-create
			ref="schedulecreate"
			@reload="reload"
			:user="user"
			:isAuth="isAuth">
		</schedule-create>

		<agreement-create
			ref="createAgreement"
			:currentCustomer="data"
			@reload="reload"
			:user="user"
			:isAuth="isAuth">
		</agreement-create>

		<request-create
			@reload="reload()"
			@openEditRequest="openEditRequest"
			ref="requestCreate"
			:user="user"
			:isAuth="isAuth">
		</request-create>
		<request-edit
			@reload="reload()"
			ref="requestEdit"
			:user="user"
			:isAuth="isAuth">
		</request-edit>
	</div>
</template>

<script>
	import swal from 'sweetalert2'

	import CreateProject from '@/components/projects/projects/views/Create.vue'
	import TaskCreate from '@/components/projects/tasks/views/Create.vue'
	import ScheduleCreate from '@/components/projects/schedules/views/Create.vue'
	import AgreementCreate from '@/components/agreements/views/Create.vue'
	import RequestCreate from '@/components/requests/views/Create.vue'
	import RequestEdit from '@/components/requests/views/Edit.vue'

	export default {
		props: ['user', 'isAuth', 'data'],
		components: {
			'create-project': CreateProject,
			'task-create': TaskCreate,
			'schedule-create': ScheduleCreate,
			'agreement-create': AgreementCreate,
			'request-create': RequestCreate,
			'request-edit': RequestEdit,
		},
		data () {
			return {
				modal: {
					selector: 'modal-add-resource-customer'
				},
			}
		},
		methods: {
			open() {
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			reload() {
				this.$emit('reload')
			},
			//--
			editOrContinue(response, type) {
				var that = this
				swal({
					title: response.body.title,
					text: response.body.text,
					type: response.body.type,
					showCancelButton: true,
					confirmButtonColor: '#2cabe3',
					confirmButtonText: 'Editar',
					cancelButtonText: 'Continuar',
				}).then(function () {
					if(type == 'budget') {
						that.$router.push('/' + that.$i18n.locale + '/' + that.$platform.slug + '/admin/management/budgets/' + response.body.data.id + '/edit')
					} else if(type == 'order'){
						that.$router.push('/' + that.$i18n.locale + '/' + that.$platform.slug + '/admin/management/orders/' + response.body.data.id + '/edit')
					} else if(type == 'invoice') {
						that.$router.push('/' + that.$i18n.locale + '/' + that.$platform.slug + '/admin/management/invoices/' + response.body.data.id + '/edit')
					}
				}).catch(swal.noop)
			},
			addRequest() {
				this.close()
				var that = this
				this.$refs.requestCreate.open(this.data, 'customer')
			},
			addBudget() {
				this.close()
				var that = this
				var data = {
					customer_id: this.data.id
				}
				swal.queue([{
					title: this.$t("messages.attention"),
					text: this.$t("messages.budget_will_be_created"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.post('admin/management/budgets', data)
							.then(response => {
								that.$emit('reload')
								that.editOrContinue(response, 'budget')
							}).catch(function(response) {
								console.log(response)
							})
						})
					}
				}]).catch(swal.noop)
			},
			addOrder() {
				this.close()
				var that = this

				var data = {
					currency_id: this.$platform.setting.currency_id,
					lang_id: this.$platform.setting.lang_id,
					customer_id: this.data.id,
				}

				swal.queue([{
					title: that.$t("messages.attention"),
					text: "¿Esta seguro de generar un pedido?",
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.post('admin/management/orders', data)
							.then(response => {
									that.$emit('reload')
									that.editOrContinue(response, 'order')
							}).catch(function(response) {
								console.log(response)
							})
						})
					}
				}]).catch(swal.noop)
			},
			addInvoice() {
				this.close()
				var that = this

				var data = {
					tax_id: this.$platform.setting.tax_id,
					currency_id: this.$platform.setting.currency_id,
					lang_id: this.$platform.setting.lang_id,
					customer_id: this.data.id,
				}

				swal.queue([{
					title: that.$t("messages.attention"),
					text: "¿Esta seguro de generar este documento?",
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.post('admin/management/invoices', data)
							.then(response => {
								that.$emit('reload')
								that.editOrContinue(response, 'invoice')
							}).catch(function(response) {
								console.log(response)
							})
						})
					}
				}]).catch(swal.noop)
			},
			addProject() {
				this.close()
				this.$refs.createProject.open()
			},
			addAgreement() {
				this.close()
				this.$refs.createAgreement.open()
			},
			//--
			openCreateSchedule(item) {
				this.$refs.schedulecreate.item = item
				this.$refs.schedulecreate.open()
			},
			openTaskCreate(data) {
				this.$refs.taskCreate.open(data)
			},
			openEditRequest(request) {
				this.$refs.requestEdit.open(request)
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/components/customers/views/Add.vue